/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any */
import { createFileRoute, useParams, useNavigate } from '@tanstack/react-router'
import { Badge } from '@/components/ui/badge'
import { useEstimatesList } from '@/hooks/useEstimates'

export const Route = createFileRoute('/_authenticated/service-cases/$id/estimates')({
  component: CaseEstimatesTab,
})

function CaseEstimatesTab() {
  const { id } = useParams({ from: '/_authenticated/service-cases/$id' })
  const navigate = useNavigate()
  const { data: estimatesData } = useEstimatesList({ service_case_id: id })
  const estimates = (estimatesData as any)?.data ?? []

  if (estimates.length === 0) {
    return <p className="text-sm text-muted-foreground p-4">No estimates linked to this case.</p>
  }

  return (
    <div className="space-y-2">
      {estimates.map((e: any) => (
        <div key={e.id} className="p-3 border rounded-lg cursor-pointer hover:bg-muted/50" onClick={() => navigate({ to: `/estimates/${e.id}` })}>
          <div className="flex items-center justify-between">
            <span className="font-medium">{e.estimate_number}</span>
            <div className="flex gap-1"><Badge>{e.status}</Badge><span className="text-sm">${e.total}</span></div>
          </div>
        </div>
      ))}
    </div>
  )
}
